import {
  Checkbox,
  Flex,
  Input,
  Img,
  InputProps,
  VStack,
  Text,
  HStack,
  Button,
} from "@chakra-ui/react";
import { useState } from "react";

interface IProps extends InputProps {
  onSearch?: (text?: string, isHis?: boolean) => void;
}

export default function SearchContainer({
  placeholder,
  onSearch,
  ...props
}: IProps) {
  const [value, setValue] = useState<string>();
  const [isHistory, setIsHistory] = useState<boolean>();

  const handleSearch = () => {
    if (onSearch) {
      const temp = value;
      setValue("");
      setIsHistory(false);
      onSearch(temp, isHistory);
    }
  };
  return (
    <HStack alignItems="flex-start">
      <Flex
        position="relative"
        flexDirection="row"
        justifyContent="center"
        alignItems="center"
        minW="200px"
        bg="#f1f1f1"
        px="10px"
        mr="10px"
        borderRadius="5px"
      >
        <VStack alignItems="flex-start">
          <Input
            placeholder={placeholder}
            border="none"
            _focusVisible={{ border: "none" }}
            value={value}
            onChange={(e) => setValue(e.target.value)}
          />
        </VStack>
        <Checkbox borderLeft="1px solid #fff" paddingLeft="10px" defaultChecked={false}
          isChecked={isHistory}
          onChange={(e) => setIsHistory(pre => !pre)}
        >
          <Text color="rgba(0,0,0, 0.5)" fontSize="14px">
            Tra cứu lịch sử
          </Text>
        </Checkbox>
      </Flex>
      <Button>
        <Img src="./imgs/search.svg" cursor="pointer" onClick={handleSearch} />
      </Button>
    </HStack>
  );
}
